import { LEVEL_COUNT, buildLevel } from './levels';
import { loadSave, saveSave } from '../core/save';
export const STARTING_STATS = {
    stats: {
        range: 2, maxBombs: 1,
        wallPass: false, bombPass: false, flamePass: false,
        remote: false, kick: false,
    },
    speed: 2.0,
    lives: 3,
    score: 0,
};
/**
 * Менеджер кампанії — зберігає поточний рівень, прогрес, рахунок і несе
 * вибрані power-up'и між рівнями.
 *
 * Семантика стану:
 *   • переходимо на наступний рівень → stats/lives/score переносяться
 *   • Game Over (втратили всі життя) → реєструємо high score, скидаємо до STARTING_STATS
 *   • Continue з меню → починаємо з рівня `save.unlockedLevel` зі STARTING_STATS
 */
export class Campaign {
    current;
    carried;
    save;
    startedAtMs;
    constructor(startLevel = 1) {
        this.save = loadSave();
        this.current = clamp(startLevel, 1, LEVEL_COUNT);
        this.carried = cloneCarried(STARTING_STATS);
        this.startedAtMs = (typeof performance !== 'undefined' ? performance.now() : Date.now());
    }
    config() {
        return buildLevel(this.current);
    }
    /** Гравець завершив поточний рівень. Повертає true, якщо є наступний. */
    advance(carried) {
        this.carried = cloneCarried(carried);
        if (this.current >= LEVEL_COUNT) {
            this.commitFinish(carried.score);
            return false;
        }
        this.current += 1;
        if (this.current > this.save.unlockedLevel) {
            this.save.unlockedLevel = Math.min(LEVEL_COUNT, this.current);
            saveSave(this.save);
        }
        return true;
    }
    /** Гравець помер: фінальний рахунок, скидаємо stats. Повертає оновлений save. */
    gameOver(finalScore) {
        if (finalScore > this.save.highScore) {
            this.save.highScore = finalScore;
            saveSave(this.save);
        }
        return this.save;
    }
    /** Викликати, коли пройшов 50-й рівень. Зберігає швидкість проходження. */
    commitFinish(finalScore) {
        if (finalScore > this.save.highScore)
            this.save.highScore = finalScore;
        const elapsed = ((typeof performance !== 'undefined' ? performance.now() : Date.now()) - this.startedAtMs) | 0;
        if (this.save.fastestRunMs === null || elapsed < this.save.fastestRunMs) {
            this.save.fastestRunMs = elapsed;
        }
        saveSave(this.save);
    }
}
export function cloneCarried(c) {
    return {
        stats: { ...c.stats },
        speed: c.speed,
        lives: c.lives,
        score: c.score,
    };
}
function clamp(n, lo, hi) {
    return Math.max(lo, Math.min(hi, n | 0));
}
